import { useState, useEffect } from "react";
import api from "@/utils/axios-utils";
import type { DropdownOption } from "../components/MultiSelectDropdown";

export const MAX_LESSONS_PER_SPACE = 3;

type UseSpaceFormOptionsResult = {
  classrooms: DropdownOption[];
  classroomsLoading: boolean;
  lessons: DropdownOption[];
  lessonsLoading: boolean;
};

export function useSpaceFormOptions(): UseSpaceFormOptionsResult {
  const [classrooms, setClassrooms] = useState<DropdownOption[]>([]);
  const [classroomsLoading, setClassroomsLoading] = useState(true);
  const [lessons, setLessons] = useState<DropdownOption[]>([]);
  const [lessonsLoading, setLessonsLoading] = useState(true);

  useEffect(() => {
    api
      .get<DropdownOption[]>("/classrooms")
      .then((res) => setClassrooms(res.data))
      .catch(() => {})
      .finally(() => setClassroomsLoading(false));

    api
      .get<{ id: number; name: string }[]>("/spaces/available-lessons")
      .then((res) =>
        setLessons(res.data.map((l) => ({ id: l.id, name: l.name }))),
      )
      .catch(() => {})
      .finally(() => setLessonsLoading(false));
  }, []);

  return { classrooms, classroomsLoading, lessons, lessonsLoading };
}
